import { useEffect, useState } from "react";

/** How long a loading placeholder waits before it draws (DESIGN.md · Loading). */
export const SKELETON_DELAY = 150;

/**
 * True once `delay` ms have passed with `active` true. A skeleton that waits this long never
 * flashes for an answer that lands first (a warm cache, a prefetched record, a fast page); one
 * that is still needed after it appears in the same place it would have. `active` false resets.
 */
export function useDelayedVisible(active = true, delay = SKELETON_DELAY): boolean {
    const [elapsed, setElapsed] = useState(false);
    useEffect(() => {
        if (!active) {
            setElapsed(false);
            return undefined;
        }
        const timer = window.setTimeout(() => setElapsed(true), delay);
        return () => window.clearTimeout(timer);
    }, [active, delay]);
    return active && elapsed;
}
